import { fg } from '@confluence/feature-gating';

/**
 * Resolves the correct macro extension key based on feature gates.
 *
 * Currently handles the migration from Connect questionslist-macro to native questionslist-macro-native:
 * - When cq_native_macro gate is ON: questionslist-macro → questionslist-macro-native
 * - When cq_native_macro gate is OFF: returns original key
 */
export const resolveQuestionsMacroExtensionKey = (extensionKey: string): string => {
	if (extensionKey === 'questionslist-macro' && fg('cq_native_macro')) {
		return 'questionslist-macro-native';
	}
	return extensionKey;
};

/**
 * Determines which macros should appear in the Quick Insert menu (/macro commands)
 * based on feature gates.
 *
 * Note: This does NOT remove manifests entirely - both manifests still exist for lookups.
 * This only controls what appears in the Quick Insert UI.
 */
export const shouldIncludeMacroInQuickInsert = (macroKey: string): boolean => {
	// When cq_native_macro is enabled, hide the Connect macro from Quick Insert
	// (existing macros with this key will still render via handler hijacking)
	if (macroKey === 'questionslist-macro' && fg('cq_native_macro')) {
		return false;
	}

	// When cq_native_macro is disabled, hide the native macro from Quick Insert
	if (macroKey === 'questionslist-macro-native' && !fg('cq_native_macro')) {
		return false;
	}

	return true;
};
